class BonusAiStorage {
    public storeVarName = 'bonus-current-file';
    public pathToViewer = '/pdfjs/web/viewer.html';
    private static instance: BonusAiStorage;
    public storeMethod: 'session' | 'memory' = 'memory';
    private constructor() {
    }

    static getInstance(): BonusAiStorage {
        if (!BonusAiStorage.instance) {
            BonusAiStorage.instance = new BonusAiStorage();
        }
        return BonusAiStorage.instance;
    }

    get(): string | null {
        if (this.storeMethod === 'memory') {
            return window[this.storeVarName] || null;
        }
        else {
            return sessionStorage.getItem(this.storeVarName);
        }
    }
    set(data: string | null): void {
        if (data) {
            if (this.storeMethod === 'memory') {
                window[this.storeVarName] = data;
            }
            else {
                sessionStorage.setItem(this.storeVarName, data);
            }
        } else {
            this.remove();
        }
    }
    remove(): void {
        if (this.storeMethod === 'memory') {
            delete window[this.storeVarName];
        }
        else {
            sessionStorage.removeItem(this.storeVarName);
        }
    }
    get srcUrl(): string {
        const storeVarName = this.storeVarName;
        const pathToViewer = this.pathToViewer;
        if (!this.get()) {
            return '';
        }
        const url = new URL(pathToViewer, window.location.origin);
        if(this.storeMethod === 'memory') {
            window['getPdfData'] = function() {
                return window[storeVarName] || null;
            }
            url.searchParams.set('parent', 'getPdfData');
        }
        else {
            url.searchParams.set('session', storeVarName);
        }
        return url.toString();
    }
}
export const bonusAiStorage = BonusAiStorage.getInstance();